import { MetricTarget } from '../../../enum';
import { WorkType } from '../queue/types';
var PATIENCE_RETRY_WORK_TYPES = new Set([WorkType.InboundCalls, WorkType.Chat, WorkType.Other]);
export function appliesPatienceRetryFields(params) {
    var isDeferrable = params.isDeferrable, worktypeId = params.worktypeId, metricTarget = params.metricTarget;
    if (isDeferrable)
        return false;
    if (worktypeId == null)
        return false;
    if (!PATIENCE_RETRY_WORK_TYPES.has(worktypeId))
        return false;
    if (metricTarget !== MetricTarget.ServiceLevel && metricTarget !== MetricTarget.ASA)
        return false;
    return true;
}
